module.exports = __webpack_public_path__ + "static/media/fj.74e854d9.svg";